module.exports = __webpack_public_path__ + "img/pet_record.7412cdaa.png";